import {
    AbstractToScore as AbstractToScoreView,
    AbstractScoring as AbstractScoringView,
    AbstractScored as AbstractScoredView,
    AbstractScoreEdit as AbstractScoreEditView,
} from 'views/DashboardJudge';

const routes = [
    {
        path: '/dashboard/judge/abstract-to-score',
        element: <AbstractToScoreView />,
    },
    {
        path: '/dashboard/judge/abstract-scored',
        element: <AbstractScoredView />,
    },
    {
        path: '/dashboard/judge/abstract-score-edit/:id',
        element: <AbstractScoreEditView />,
    },
    {
        path: '/dashboard/judge/abstract-scoring/:id',
        element: <AbstractScoringView />,
    },
];

export default routes;
